var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBritishVirginIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.0001H16C16 15.9857 16 15.9717 16 15.9573C15.9858 15.9716 15.9715 15.9858 15.9572 16.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09469 2.08691C5.59225 3.51185 3.51181 5.59223 2.08694 8.09466V16H6.26087V6.26098V6.26085H16C16 4.94441 16 3.69029 16 2.08691H8.09469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 16L18.6319 20.3246C19.4424 21.8877 21.0742 22.9565 22.9565 22.9565C24.8388 22.9565 26.4706 21.8877 27.2811 20.3246L22.9565 16Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0325L10.3153 8.3479H8.34781V8.34803L15.9999 16H16C16 16 16 14.6433 16 14.0325Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 8.3479V16V16.0001C18.087 19.7275 22.9565 20.8696 22.9565 20.8696C22.9565 20.8696 27.826 19.7275 27.8261 16.0001V16V8.3479H18.0869Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9131 11.8262H24V17.3914H21.9131V11.8262Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 12.8695C23.5328 12.8695 24 12.4023 24 11.826C24 11.2497 23.5328 10.7825 22.9565 10.7825C22.3802 10.7825 21.913 11.2497 21.913 11.826C21.913 12.4023 22.3802 12.8695 22.9565 12.8695Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4785 9.73926H20.8698V11.1306H19.4785V9.73926Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4785 12.8696H20.8698V14.2609H19.4785V12.8696Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4785 16.0002H20.8698V17.3916H19.4785V16.0002Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0438 9.73926H26.4351V11.1306H25.0438V9.73926Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0438 12.8696H26.4351V14.2609H25.0438V12.8696Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0438 16.0002H26.4351V17.3916H25.0438V16.0002Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBritishVirginIslands);
export default __webpack_public_path__ + "static/media/flag_british_virgin_islands.a159a3380413b40a077a52f2e44cb2af.svg";
export { ForwardRef as ReactComponent };